/* eslint-disable jsx-a11y/anchor-is-valid */
// MpCheckout — inicia el pago de una orden elevax con Mercado Pago (Checkout Pro).
// Ruta: /mp/pay/:org/:order_id
// Uso: link de pago standalone (ej. generado a pedido de un cliente por WhatsApp/
// teléfono). El checkout embebido normal vive en quickseller_front (Wallet Brick);
// esto es la vía alterna para cuando no hay sesión de checkout activa.
//
//   1. Pide el email del comprador (el back valida que coincida con el dueño de
//      la orden antes de generar la preference — evita filtrar monto/email de
//      órdenes ajenas adivinando el order_id, y evita loguear el email en la URL).
//   2. Pide la preference al back (createMpPreference) y muestra el monto.
//   3. Botón que redirige al checkout hospedado por MP.
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { MDBSpinner } from "mdb-react-ui-kit";
import TopBar from "../components/TopBar";
import { createMpPreference } from "../utils/mpApi";

export default function MpCheckout() {
  const { org, order_id } = useParams();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [pref, setPref] = useState(null); // { initPoint, sandboxInitPoint, amount, currency }

  const submitEmail = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError("");
    const resp = await createMpPreference(org, order_id, email.trim());
    setLoading(false);
    if (resp.status && (resp.initPoint || resp.sandboxInitPoint)) {
      setPref(resp);
    } else {
      setError(resp.message || "No se pudo iniciar el pago");
    }
  };

  const goToMp = () => {
    // sandbox_init_point si estamos en test; init_point en prod.
    const url = pref.sandboxInitPoint || pref.initPoint;
    window.location.href = url;
  };

  return (
    <>
      <TopBar subtitle="Pago con Mercado Pago" />
      <div className="xp-page">
        <div className="xp-card">
          <div className="xp-badge xp-badge-neutral">
            <i className="fas fa-credit-card"></i>
          </div>

          {!pref && (
            <>
              <h2>Confirma tu pedido</h2>
              <p className="xp-sub">
                Ingresa el correo con el que se registró el pedido #{order_id} para
                continuar con el pago.
              </p>
              <form className="xp-search" onSubmit={submitEmail}>
                <label htmlFor="email">Correo electrónico</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="tu@email.com"
                  autoComplete="off"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  required
                />
                <button type="submit" className="xp-btn" disabled={loading}>
                  <i className="fas fa-arrow-right"></i>{" "}
                  {loading ? "Verificando..." : "Continuar"}
                </button>
                {error && <p className="xp-form-error">{error}</p>}
              </form>
              {loading && (
                <div className="contenedor-loader">
                  <MDBSpinner grow color="info" style={{ width: "2rem", height: "2rem" }}>
                    <span className="visually-hidden">Loading...</span>
                  </MDBSpinner>
                </div>
              )}
            </>
          )}

          {pref && (
            <>
              <h2>Confirma tu pago</h2>
              <p className="xp-sub">
                Serás redirigido a la pasarela segura de Mercado Pago para completar
                tu pago con tarjeta, QR o saldo.
              </p>
              <div className="xp-summary">
                <div className="xp-summary-row">
                  <span>Pedido</span>
                  <b>{order_id}</b>
                </div>
                <div className="xp-summary-row">
                  <span>Total</span>
                  <b>
                    {pref.amount} {pref.currency}
                  </b>
                </div>
              </div>
              <button type="button" className="xp-btn" onClick={goToMp}>
                <i className="fas fa-lock"></i> Pagar con Mercado Pago
              </button>
            </>
          )}

          <div className="xp-trust">
            <i className="fas fa-lock"></i> Pago seguro · Transacción protegida
          </div>
        </div>
      </div>
    </>
  );
}
